export default __webpack_public_path__ + "static/media/Rectangle-138.2c6225e9.png";